module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/tiktok-badge-c7c3abe5963ca17658bd0a3dd173ac1c.svg";